import { useEffect, useState } from 'react';
import { CompanyDetailsInterface, OrderData, RoomServiceLocation } from '../../../services/exports/Interfaces';
import collect from 'collect.js';

export interface RoomServiceLocationSchema {
  roomServiceDetails?: string;
  roomServiceLocation: RoomServiceLocation;
}

interface Props {
  cachedOrder?: Partial<OrderData>;
  company: CompanyDetailsInterface;
}

const useRoomServiceLocationForm = (props: Props) => {
  const { company, cachedOrder } = props;
  const [data, setData] = useState<RoomServiceLocationSchema>({
    roomServiceDetails: cachedOrder?.room_service_details ?? '',
    roomServiceLocation: getDefaultRoomServiceLocation(),
  });

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      roomServiceLocation: getDefaultRoomServiceLocation(),
    }));
  }, [company?.room_service_locations]);

  function getDefaultRoomServiceLocation(): RoomServiceLocation {
    return (
      collect(company?.room_service_locations).firstWhere('id', cachedOrder?.room_service_location_id) ??
      company?.room_service_locations?.[0] ??
      null
    );
  }
  const setRoomServiceLocation = (id: string) => {
    const roomServiceLocation = collect(company?.room_service_locations).firstWhere('id', +id);

    setData((prev) => ({ ...prev, roomServiceLocation }));
  };
  const setRoomServiceDetails = (roomServiceDetails: string) => setData((prev) => ({ ...prev, roomServiceDetails }));

  return {
    data,
    setRoomServiceLocation,
    setRoomServiceDetails,
  };
};

export default useRoomServiceLocationForm;
